import React, { useState } from 'react'
import { Row, Col, Card, Form, Input, Spin } from 'antd';
import { __custom_card } from '../__custom_card'
import { SelectBox, InputBox, isBrowser, DatePicker } from '../../../../shared/custom-ant-d'
import { formField } from './_formField';
import passwordValidator from 'password-validator';
import { DatePicker as DatePickerBV } from 'antd';
import moment from 'moment';
import { PhoneRegex } from '../../../../shared/helpers';

const schema = new passwordValidator();
export const FormTTO = (props) => {
  const {
    form, disableAll,
    allCountryList,
    emergencyContactRelationshipList,
    languageList,
    maritalStatusList, nameSuffixList,
    salutationList,
    usGenderList
  } = props;

  const [disableMailFields, setDisableMailFields] = useState(false);

  const validateTTOFields = (_, value) => {
    let national_Identification_Card_TT = (form.getFieldValue(formField.national_Identification_Card_TT) == null || form.getFieldValue(formField.national_Identification_Card_TT) === "");
    let passportNo_TT = (form.getFieldValue(formField.passportNo_TT) == null || form.getFieldValue(formField.passportNo_TT) === "");
   //[formField.national_Identification_Card_TT,formField.passportNo_TT,formField.national_Insurance_Number_TT,formField.biR_TT]
    let regexPattern = {
      nIC_TT: /^[\d]{11}$/,
      passport: /^[A-Za-z]{2}[\d]{6}$/
    };

    if (national_Identification_Card_TT && passportNo_TT) {
      return `${_.fullField} is required.`
    }

    if (value !== null) {
      if (_.field == formField.national_Identification_Card_TT) {
        if (regexPattern.nIC_TT.test(value) || value == '')
          return null
        else
          return 'Invalid format. YYYYMMDDXXX.'
      }

      if (_.field == formField.passportNo_TT) {
        if (regexPattern.passport.test(value) || value == '')
          return null
        else
          return 'Invalid format. Use format AANNNNNN.'
      }
    }
    else
      return null
  }

  return (
    <>
      <Card
        type="inner"
      >
        <__custom_card title={'Enter name as shown on National ID Card'}>
          <Row justify={'start'}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="First Name"
                name={formField.legalFirstName}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Middle Name"
                name={formField.middleName}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Last Name"
                name={formField.legalLastName}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                {
                  (isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Second Last Name"
                name={formField.secondLastName}
              >
                {
                  (isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Salutation"
                name={formField.salutation}
              >
                <SelectBox
                  data={
                    salutationList && (
                      salutationList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  label={''}
                  disabled={disableAll}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!salutationList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Suffix"
                name={formField.suffix}
              >
                <SelectBox
                  data={
                    nameSuffixList && (
                      nameSuffixList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!nameSuffixList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Enter Gender and Marital Status'}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Gender"
                name={formField.gender}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <SelectBox
                  data={
                    usGenderList && (
                      usGenderList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!usGenderList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Marital Status"
                name={formField.maritalStatus}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <SelectBox
                  data={
                    maritalStatusList && (
                      maritalStatusList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!maritalStatusList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Enter Language Skills'}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Language"
                name={formField.primaryLanguage}
              >
                <SelectBox
                  data={
                    languageList && (
                      languageList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!languageList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Seconday Language"
                name={formField.secondaryLanguage}
              >
                <SelectBox
                  data={
                    languageList && (
                      languageList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!languageList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Biographical and National ID Information'}>
          <Row justify='start' >
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Date of Birth"
                name={formField.dob}
                rules={[
                  {
                    required: true
                  },
                  () => ({
                    validator(_, value) {
                      var now = moment(new Date()); //todays date
                      var end = moment(value); // another date
                      var duration = moment.duration(now.diff(end));
                      var years = duration.asYears();
                      if (years >= 18) {
                        return Promise.resolve();
                      }
                      else {
                        return Promise.reject('You must be 18 years or older to be hired.')
                      }
                    }
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (
                      <DatePickerBV
                        disabled={disableAll}
                        format={'MM/DD/YYYY'}
                        label={''}
                        onChange={(value) => {
                          // form.setFieldsValue({ dob: value })
                        }}
                      />
                    ) :
                    (
                      <DatePicker
                        disabled={disableAll}
                        label={''}
                        onChange={(value) => {
                          // form.setFieldsValue({ dob: value })
                        }}
                      />
                    )
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Country of Birth"
                name={formField.countryOfBirth}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <SelectBox
                  data={
                    allCountryList && (
                      allCountryList.map((item, i) => {
                        return ({ value: item.countryName, label: item.countryName })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!allCountryList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Nationality"
                name={formField.nationality}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <SelectBox
                  data={
                    allCountryList && (
                      allCountryList.map((item, i) => {
                        return ({ value: item.countryName, label: item.countryName })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!allCountryList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="National ID Country"
                name={formField.jobReqCountryCode}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                {
                  (isBrowser) ? (<Input disabled={true} />) : (<InputBox disabled={true} />)
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="National Identification Card"
                name={formField.national_Identification_Card_TT}
                dependencies={[formField.passportNo_TT, formField.national_Insurance_Number_TT, formField.biR_TT]}
                rules={[
                  () => ({
                    validator(_, value) {
                      let errorMsg = validateTTOFields(_, value);
                      if (errorMsg !== null) {
                        return Promise.reject(errorMsg)
                      }
                      else {
                        return Promise.resolve();
                      }
                    }
                  }),
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Passport"
                name={formField.passportNo_TT}
                dependencies={[formField.national_Identification_Card_TT, formField.national_Insurance_Number_TT, formField.biR_TT]}
                rules={[
                  () => ({
                    validator(_, value) {
                      let errorMsg = validateTTOFields(_, value);
                      if (errorMsg !== null) {
                        return Promise.reject(errorMsg)
                      }
                      else {
                        return Promise.resolve();
                      }
                    }
                  }),
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="National Insurance Number"
                name={formField.national_Insurance_Number_TT}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Board of Inland Revenue (BIR)"
                name={formField.biR_TT}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Primary Home Address'}>
          <Row justify='start'>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="CountryCode"
                name={formField.countryCode}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Country"
                name={formField.countryName}
                rules={[
                  { required: true },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList && (
                      allCountryList.map((item, i) => {
                        return ({ value: item.countryName, label: item.countryName })
                      })
                    )
                  }
                  disabled={true}
                  label={''}
                  onChange={(value) => {
                    var label = allCountryList.filter(i => i.countryName == value);
                    form.setFieldsValue({ CountryCode: label[0]?.CountryCode })
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ CountryName: value })
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!allCountryList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Street and House Number"
                name={formField.streetAndHouseNumber}
                rules={[
                  { required: true },
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="City"
                name={formField.city}
                rules={[
                  { required: true },
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 8, offset: 1 }} xs={24}>
              <Form.Item
                label="Is your Primary address same as Current/Mailing?"
                name={formField.isPrimaryAddressSameAsMailing}
                rules={[
                  { required: true },
                ]}
              >
                <SelectBox
                  data={
                    [
                      { value: true, label: 'Yes' },
                      { value: false, label: 'No' },
                    ]
                  }
                  disabled={disableAll}
                  label={''}
                  onChange={(value) => {
                    setDisableMailFields(value);
                    if (value == true) {
                      let country = allCountryList.filter(i => i.countryName == form.getFieldValue(formField.countryName));

                      form.setFieldsValue({
                        MailingCountryID: country[0]?.generalCountryID,
                        MailingCountryCode: form.getFieldValue(formField.countryCode),
                        MailingCountryName: form.getFieldValue(formField.countryName),
                        MailingStreetAndHouseNumber: form.getFieldValue(formField.streetAndHouseNumber),
                        MailingCity: form.getFieldValue(formField.city)
                      });
                    }
                    else if (value == false) {
                      form.setFieldsValue({
                        MailingCountryID: null,
                        MailingCountryCode: null,
                        MailingCountryName: null,
                        MailingStreetAndHouseNumber: null,
                        MailingCity: null
                      });
                    }
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Enter Current/Mailing Address'}>
          <Row justify="start" gutter={8}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="mailingCountryID"
                name={formField.mailingCountryID}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="mailingCountryCode"
                name={formField.mailingCountryCode}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Country"
                name={formField.mailingCountryName}
                rules={[
                  { required: true },
                ]}
              >
                <SelectBox
                  data={
                    allCountryList && (
                      allCountryList.map((item, i) => {
                        return ({ value: item.countryName, label: item.countryName })
                      })
                    )
                  }
                  disabled={disableAll || disableMailFields}
                  label={''}
                  onChange={(value) => {
                    var label = allCountryList.filter(i => i.countryName == value);
                    form.setFieldsValue({ MailingCountryID: label[0]?.generalCountryID })
                    form.setFieldsValue({ MailingCountryCode: label[0]?.CountryCode })
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ MailingCountryName: value })
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!allCountryList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Street and House Number"
                name={formField.mailingStreetAndHouseNumber}
                rules={[
                  { required: true },
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll || disableMailFields} />) :
                  (<InputBox disabled={disableAll || disableMailFields} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="City"
                name={formField.mailingCity}
                rules={[
                  { required: true },
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll || disableMailFields} />) :
                  (<InputBox disabled={disableAll || disableMailFields} />)}
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Enter Contact Information'}>
          <Row justify="start" gutter={8}>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Mobile/Primary Phone"
                name={formField.mobilePrimaryPhone}
                rules={[
                  {
                    required: true
                  },
                  () => ({
                    validator(_, value) {
                      let isCheck = PhoneRegex('TTO')
                      if (!isCheck.regex.test(value)) {
                        return Promise.reject(isCheck.msg)
                      }
                      else {
                        return Promise.resolve();
                      }
                    }
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input disabled={disableAll} />) :
                    (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Secondary Phone"
                name={formField.secondaryPhone}
                rules={[
                  () => ({
                    validator(_, value) {
                      schema
                        .is().not().letters()
                        .is().not().symbols();

                      if (value == null) {
                        return Promise.resolve();
                      }

                      if (value != null && value.length != 7) {
                        return Promise.reject('Mobile/Primary Phone must be 7 digit number.')
                      } else if (!schema.validate(value, { list: true }).includes('letters') && !schema.validate(value, { list: true }).includes('symbols')) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Secondary Phone must contain numbers only.')
                      }
                    }
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input disabled={disableAll} />) :
                    (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
        <__custom_card title={'Tell us who to contact in Case of Emergency'}>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="emergencyContactRelationID1"
                name={formField.emergencyContactRelationID1}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Relationship"
                name={formField.emergencyContactRelationName1}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <SelectBox
                  data={
                    emergencyContactRelationshipList && (
                      emergencyContactRelationshipList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  onChange={(value) => {
                    var label = emergencyContactRelationshipList.filter(i => i.expText == value);
                    form.setFieldsValue({ EmergencyContactRelationID1: label[0]?.codeValueID })
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ EmergencyContactRelationID1: null })
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!emergencyContactRelationshipList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Name"
                name={formField.emergencyContactName1}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Phone Number"
                name={formField.emergencyContactPhone1}
                rules={[
                  {
                    required: true
                  },
                  () => ({
                    validator(_, value) {
                      if (value === "") {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject('Primary Phone must be a number.')
                      }
                      else if (value.length < 7 || value.length > 10) {
                        return Promise.reject('Primary Phone must be atleast 7-10 digits.')
                      }
                      else {
                        return Promise.resolve();
                      }
                    }
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input disabled={disableAll} />) :
                    (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Email Address"
                name={formField.emergencyContactEmail1}
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid email"
                  },
                ]}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row justify="start">
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="emergencyContactRelationID2"
                name={formField.emergencyContactRelationID2}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Relationship"
                name={formField.emergencyContactRelationName2}
              >
                <SelectBox
                  data={
                    emergencyContactRelationshipList && (
                      emergencyContactRelationshipList.map((item, i) => {
                        return ({ value: item.expText, label: item.expText })
                      })
                    )
                  }
                  disabled={disableAll}
                  label={''}
                  onChange={(value) => {
                    var label = emergencyContactRelationshipList.filter(i => i.expText == value);
                    form.setFieldsValue({ emergencyContactRelationID2: label[0]?.codeValueID })
                  }}
                  onDismiss={(value) => {
                    form.setFieldsValue({ emergencyContactRelationID2: null })
                  }}
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={!emergencyContactRelationshipList ? <Spin size="small" /> : null}
                />
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Name"
                name={formField.emergencyContactName2}
              >
                {(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                label="Primary Phone Number"
                name={formField.emergencyContactPhone2}
                rules={[
                  () => ({
                    validator(_, value) {
                      if (value === "" || value === undefined) {
                        return Promise.resolve();
                      }

                      var regex = /^[0-9]+$/;
                      if (!regex.test(value)) {
                        return Promise.reject('Primary Phone must be a number.')
                      }
                      else if (value.length < 7 || value.length > 10) {
                        return Promise.reject('Primary Phone must be atleast 7-10 digits.')
                      }
                      else {
                        return Promise.resolve();
                      }
                    }
                  }),
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input disabled={disableAll} />) :
                    (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
            <Col md={{ span: 7, offset: 1 }} xs={24}>
              <Form.Item
                labelCol={{ md: { offset: 1 } }}
                wrapperCol={{ md: { span: 24 } }}
                label="Email Address"
                name={formField.emergencyContactEmail2}
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid email"
                  },
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input disabled={disableAll} />) :
                    (<InputBox disabled={disableAll} />)
                }
              </Form.Item>
            </Col>
          </Row>
        </__custom_card>
      </Card>
    </>
  )
}
